import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const learnerReviewsApiService = createApi({
  reducerPath: "learnerReviewsApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getAllLearnerReviews: builder.query({
      query: (params) => {
        let query = queryParams(params);
        return {
          url: `learner-review/course/review-list${query}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetAllLearnerReviewsQuery } = learnerReviewsApiService;
